import React from 'react';
import {Link} from 'react-router-dom';

import {PB_ADMIN} from 'src/hooks/access-resource-constant';
import {useCurrentUser} from 'src/hooks/useCurrentUser';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Icon, {Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';

import type {VendorUser} from '../hooks/use-vendor-users';

type Props = {
    users: VendorUser[],
    deletingMap: Record<number, boolean>,
    onDelete: (userId: number) => void,
};

const numberW = 30;
const emailW = 260;
const firstNameW = 140;
const lastNameW = 140;
const roleW = 160;
const actionW = 70;


export const AssignedUsersTable: React.FC<Props> = ({users, deletingMap, onDelete}) => {
    const {hasAccessToResource} = useCurrentUser();
    const canDeleteUser = hasAccessToResource(PB_ADMIN.UPDATE_USER);
    return (
        <Table>
            <Head>
                <Row>
                    <Cell width={numberW}>#</Cell>
                    <Cell width={emailW}>Email</Cell>
                    <Cell width={firstNameW}>First Name</Cell>
                    <Cell width={lastNameW}>Last Name</Cell>
                    <Cell width={roleW}>Role</Cell>
                    <Cell width={actionW} className="text-align_center"></Cell>
                </Row>
            </Head>
            <Body>
                {users.map((user, index) => (
                    <Row key={user.userId}>
                        <Cell width={numberW}>{index + 1}</Cell>
                        <Cell width={emailW}>
                            <Link to={`/users/${user.userId}`} style={{display: 'block', maxWidth: '100%', textAlign: 'left'}}>
                                <div style={{maxWidth: '100%'}}>
                                    <EllipsisTextHint title={user.email}>
                                        {user.email}
                                    </EllipsisTextHint>
                                </div>
                            </Link>
                        </Cell>
                        <Cell width={firstNameW}>
                            <EllipsisTextHint title={user.firstName}>{user.firstName}</EllipsisTextHint>
                        </Cell>
                        <Cell width={lastNameW}>
                            <EllipsisTextHint title={user.lastName}>{user.lastName}</EllipsisTextHint>
                        </Cell>
                        <Cell width={roleW}>
                            <EllipsisTextHint title={user.role?.name ?? ''}>
                                {user.role?.name ?? ''}
                            </EllipsisTextHint>
                        </Cell>
                        <Cell width={actionW} className="text-align_center">
                            {canDeleteUser ? (
                                <Tooltip
                                    anchor={({anchorRef, getAnchorProps}) => (
                                        <FlatButton
                                            ref={anchorRef}
                                            {...getAnchorProps()}
                                            aria-label={`Remove ${user.email || 'user'}`}
                                            onClick={() => onDelete(user.userId)}
                                            disabled={Boolean(deletingMap[user.userId])}
                                            startIcon={<Icon type={Icons.TRASH}/>}
                                        />
                                    )}>
                                    Remove User
                                </Tooltip>
                            ) : null}
                        </Cell>
                    </Row>
                ))}
            </Body>
        </Table>
    );
};
